"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iScheduledDeletionConfig = exports.iCreateFolder = exports.iCreateFolderRequiredParams = exports.iCheckFolderPermissionResponse = exports.iCheckFolderPermission = exports.iFolderContent = exports.iBatchCreateFolder = exports.iSessionRevisionData = exports.iUploadSession = exports.iFileListFilterParams = exports.iFileListFilterColumnValue = exports.iEditNodeParameters = exports.iEditFileParameters = exports.iEditFolderParameters = exports.iSortingAndPaginationAPI = exports.iSortingAndPagination = exports.iOrderFile = exports.iRevisionOrFolderSimplified = exports.iRevisionConversionStatus = exports.iRevisionOrFolder = exports.iRevision = exports.iRevisionSimplified = exports._iRevisionMinimal = exports.iFolder = exports.iFolderSimplified = exports._iFolderMinimal = exports.iSchedule = exports.iSearchOptions = exports.iSearchType = exports.iFileType = exports.iPartialFolderType = exports.iNewFolderPermissionTypes = exports.iFolderPermission = exports.iPartialFileType = exports.iCustomMetadata = exports.iExtendedCustomMetadata = exports.iOrderPartial = exports.iSimplifiedCustomMetadata = exports.iMeta = exports.iNotifications = void 0;
const t = require("io-ts");
const Generic = require("./generic");
const User = require("./user");
const Preview = require("./preview");
const customMeta_1 = require("./customMeta");
const reliable_partner_status_1 = require("./reliable-partner-status");
exports.iNotifications = t.interface({
    email: t.boolean,
    pushnotifications: t.boolean
});
const _iMeta = t.intersection([
    t.interface({
        filename: t.string,
        created_at: t.union([t.string, t.number])
    }),
    t.partial({
        reliablePartnerStatus: reliable_partner_status_1.iReliablePartnerStatusValue,
        path: t.string,
        content_type: t.string,
        size: t.number,
        count: t.number
    })
]);
exports.iMeta = t.clean(_iMeta);
exports.iSimplifiedCustomMetadata = t.dictionary(t.string, t.union([t.number, t.string, t.boolean, customMeta_1.iReferenceMeta, t.null]));
exports.iOrderPartial = t.partial({
    order: t.number
});
const _iExtendedCustomMetadata = t.intersection([
    customMeta_1.iMetadata,
    t.union([
        t.interface({
            type: t.literal('reference'),
            value: customMeta_1.iReferenceMeta
        }),
        t.interface({
            id: t.number,
            type: t.keyof(customMeta_1.MetaTypePrimitive),
            value: customMeta_1.iMetaTypeValuePrimitive
        })
    ]),
    t.partial({
        uuid: t.string
    }),
    exports.iOrderPartial
]);
exports.iExtendedCustomMetadata = t.clean(_iExtendedCustomMetadata);
exports.iCustomMetadata = exports.iExtendedCustomMetadata;
exports.iPartialFileType = t.union([
    t.literal('PDF'),
    t.literal('TEXT'),
    t.literal('SPREADSHEET'),
    t.literal('IMAGE'),
    t.literal('VIDEO'),
    t.literal('PRESENTATION'),
    t.literal('DWG'),
    t.literal('IFC'),
    t.literal('OTHER')
]);
exports.iFolderPermission = t.union([
    t.literal('DENIED'),
    t.literal('READABLE'),
    t.literal('WRITABLE')
]);
exports.iNewFolderPermissionTypes = t.union([
    t.literal('DENIED'),
    t.literal('ALLOWED')
]);
exports.iPartialFolderType = t.literal('FOLDER');
exports.iFileType = t.union([exports.iPartialFileType, exports.iPartialFolderType]);
exports.iSearchType = t.union([exports.iFileType, t.literal('ADVANCED_SEARCH')]);
exports.iSearchOptions = t.partial({
    name: t.string,
    type: exports.iSearchType,
    subcontent: t.number,
    columnName: Generic.UUID
});
const __iFolderMinimal = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        parent: t.number,
        parentUuid: t.string,
        length: t.number,
        project: t.number,
        projectUuid: t.string,
        name: t.string,
        type: exports.iPartialFolderType,
        bookmarked: t.boolean,
        perm: t.number
    }),
    t.partial({
        feature: t.number,
        author: t.union([t.null, User.iAuthor]),
        notifications: exports.iNotifications,
        onAutomaticOrder: t.boolean,
        path: t.string,
        meta: exports.iMeta
    })
]);
exports.iSchedule = t.union([
    t.null,
    t.interface({
        timeFrame: t.number,
        period: t.union([
            t.literal('day'),
            t.literal('week'),
            t.literal('month'),
            t.literal('year')
        ])
    })
]);
exports._iFolderMinimal = t.clean(__iFolderMinimal);
const _iFolderSimplified = t.intersection([
    exports._iFolderMinimal,
    t.interface({
        customMeta: exports.iSimplifiedCustomMetadata
    })
]);
exports.iFolderSimplified = t.clean(_iFolderSimplified);
const _iFolder = t.intersection([
    exports._iFolderMinimal,
    t.interface({
        customMeta: t.array(exports.iCustomMetadata)
    })
]);
exports.iFolder = t.clean(_iFolder);
exports._iRevisionMinimal = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        parent: t.number,
        parentUuid: t.string,
        project: t.number,
        projectUuid: t.string,
        file: t.number,
        fileUuid: t.string,
        name: t.string,
        type: exports.iPartialFileType,
        bookmarked: t.boolean,
        version: t.number
    }),
    t.partial({
        feature: t.number,
        author: t.union([t.null, User.iAuthor]),
        notifications: exports.iNotifications,
        preview: t.union([Preview.iPreview, t.null]),
        onAutomaticOrder: t.boolean,
        path: t.string,
        meta: exports.iMeta,
        perm: t.number
    })
]);
const _iRevisionSimplified = t.intersection([
    exports._iRevisionMinimal,
    t.interface({
        customMeta: exports.iSimplifiedCustomMetadata
    })
]);
exports.iRevisionSimplified = t.clean(_iRevisionSimplified);
const _iRevision = t.intersection([
    exports._iRevisionMinimal,
    t.interface({
        customMeta: t.array(exports.iCustomMetadata)
    }),
    t.partial({
        prev: t.union([t.string, t.null]),
        next: t.union([t.string, t.null])
    })
]);
exports.iRevision = t.clean(_iRevision);
exports.iRevisionOrFolder = t.union([exports.iRevision, exports.iFolder]);
exports.iRevisionConversionStatus = t.union([
    t.literal('CONVERTED'),
    t.literal('CONVERTING'),
    t.literal('FAILED'),
    t.literal('NOT_CONVERTED')
]);
exports.iRevisionOrFolderSimplified = t.union([
    exports.iRevisionSimplified,
    exports.iFolderSimplified
]);
exports.iOrderFile = t.intersection([
    t.interface({
        excluded: t.boolean
    }),
    t.union([exports.iRevisionSimplified, exports.iFolderSimplified])
]);
const _iSortingAndPagination = t.intersection([
    t.interface({
        sortBy: t.union([t.null, t.number, t.string]),
        order: Generic.iOrder
    }),
    t.partial({
        columnId: t.string,
        columnValue: t.string,
        filters: t.dictionary(t.string, t.string),
        type: exports.iFileType
    }),
    Generic.iLimitAndOffsetFront
]);
exports.iSortingAndPagination = t.clean(_iSortingAndPagination);
// We have the api sortingAndPagination also here to make sure front and back are somewhat in sync
const _iSortingAndPaginationAPI = t.intersection([
    t.partial({
        sortBy: t.union([t.null, t.string]),
        order: Generic.iOrder
    }),
    t.partial({
        hideEmpty: t.string,
        bookmarked: t.string,
        toggleRecents: t.string,
        filters: t.dictionary(t.string, t.string),
        type: exports.iFileType
    }),
    Generic.iLimitAndOffsetApi
]);
exports.iSortingAndPaginationAPI = t.clean(_iSortingAndPaginationAPI);
const iEditCustomMeta = t.interface({
    uuid: t.string,
    value: t.union([t.number, t.string, t.boolean, t.null])
});
exports.iEditFolderParameters = t.interface({
    type: t.literal('Folder'),
    id: t.number,
    name: Generic.iNonEmptyString,
    customMeta: t.array(iEditCustomMeta)
});
exports.iEditFileParameters = t.interface({
    type: t.literal('File'),
    id: t.number,
    name: Generic.iNonEmptyString,
    customMeta: t.array(iEditCustomMeta)
});
exports.iEditNodeParameters = t.taggedUnion('type', [
    exports.iEditFolderParameters,
    exports.iEditFileParameters
]);
const _iFileListFilterColumnValue = t.interface({
    type: t.union([customMeta_1.iMetadata, t.literal('NAME')]),
    value: t.string
});
exports.iFileListFilterColumnValue = t.clean(_iFileListFilterColumnValue);
exports.iFileListFilterParams = t.interface({
    columnFilters: t.array(exports.iFileListFilterColumnValue)
});
exports.iUploadSession = t.interface({
    id: t.number,
    uuid: t.string,
    created_at: t.union([t.string, t.number]),
    author: User.iAuthor,
    pending: t.number,
    finished: t.number,
    parentUuid: t.string,
    status: t.string
});
exports.iSessionRevisionData = t.interface({
    list: t.array(exports.iRevision),
    total: t.number,
    project: t.number,
    sessionRoot: t.number
});
// Batch folder and file types
const _iBatchCreateFolder = t.intersection([
    t.interface({
        parent: t.number,
        project: t.number,
        folders: t.array(t.intersection([
            t.interface({
                name: t.string,
                description: t.string
            }),
            t.partial({
                customMeta: t.dictionary(t.string, t.union([t.string, t.number, t.boolean]))
            })
        ]))
    }),
    t.partial({
        session: t.string,
        replace: t.boolean
    })
]);
exports.iBatchCreateFolder = t.clean(_iBatchCreateFolder);
exports.iFolderContent = t.interface({
    rootId: t.number,
    rootIdentifier: t.string,
    folders: t.array(exports.iFolder)
});
exports.iCheckFolderPermission = t.interface({
    projectId: t.number,
    user: User.iUser,
    folderUuids: t.array(t.string)
});
exports.iCheckFolderPermissionResponse = t.interface({
    isAllowed: t.boolean
});
exports.iCreateFolderRequiredParams = t.interface({
    name: t.string,
    parent: t.number
});
exports.iCreateFolder = t.intersection([
    t.interface({
        type: t.string
    }),
    t.partial({
        description: t.string,
        hidden: t.boolean,
        customMeta: exports.iSimplifiedCustomMetadata
    }),
    exports.iCreateFolderRequiredParams
]);
exports.iScheduledDeletionConfig = t.intersection([
    t.interface({
        retentionTime: t.number,
        retentionTimeUnits: t.union([
            t.literal('days'),
            t.literal('weeks'),
            t.literal('months'),
            t.literal('years')
        ])
    }),
    t.partial({
        updatedAt: t.number
    })
]);
//# sourceMappingURL=file.js.map